import { DataV3 } from 'bones/utils/queryBuilder/migrate/v3/types';
import {
  DataV4,
  TopExpressionV4,
} from 'bones/utils/queryBuilder/migrate/v4/types';
import { Variable } from 'bones/utils/queryBuilder/types';

export const v4 = (data: DataV3): DataV4 => {
  const firstSubjectVariableIds: string[] = [];
  const variableIds = Array.from(
    data.query.expressions.reduce<Set<string>>((acc, subExpression) => {
      const addVariable = (obj: Variable | undefined | string) => {
        if (obj && typeof obj !== 'string') {
          acc.add(obj.id);
        }
      };
      subExpression.expressions.forEach((expression, subExpressionIdx) => {
        expression.filters.forEach((filter, filterIdx) => {
          if (subExpressionIdx === 0 && filterIdx === 0) {
            // Where Expand Results was deselected, include the first subject
            // in each root-level OR block
            firstSubjectVariableIds.push(filter.subject.id);
          }
          addVariable(filter.subject);
          addVariable(filter.comparisonSubject);
          addVariable(filter.value);
        });
      });
      return acc;
    }, new Set())
  ).sort();
  return {
    query: data.query as unknown as TopExpressionV4,
    variableIds: data.fullGraph ? variableIds : firstSubjectVariableIds,
  };
};
